import styled from 'styled-components';

const TableRow = styled.div`
  display: table-row;
  border-top: 1px solid #F1F1F1;
  &:first-child {
    border-top: none;
  }
`;

export default TableRow;
